import { render } from "./SliderControl.vue?vue&type=template&id=32c4f07c&scoped=true"
import script from "./SliderControl.vue?vue&type=script&lang=js"
export * from "./SliderControl.vue?vue&type=script&lang=js"

import "./SliderControl.vue?vue&type=style&index=0&id=32c4f07c&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c4f07c"]])

export default __exports__